import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    base_url: "https://sportips.fr/api/v1/maritima_23/endpoints",
    list_courses: [],
    classement: [],
    classement_type: "Homme",
    search_terms: "",
    logged: false,
  },
  mutations: {},
  actions: {},
  modules: {},
});
